module.exports = __webpack_public_path__ + "img/2info.1d8ef736.png";